/** @jsx jsx */
import { Box, Container, EmptyState, EmptyStateListWhite, Flex, Pagination } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { ListViewHeader } from "@/components/views";
import { useTimeReportsQuery } from "@/data/time-reports/queries/useTimeReportsQuery";

import { TimeReportsList } from "./TimeReportsList";

interface TimeReportsViewProps {}

export const TimeReportsView: FC<TimeReportsViewProps> = ({}) => {
  const { t } = useTranslation(["session", "public"]);

  const { data, setPage, setSize } = useTimeReportsQuery();

  return data.totalElements <= 0 ? (
    <Box sx={{ py: 120 }} px="sm">
      <EmptyState
        icon={<EmptyStateListWhite />}
        title={t("TIME_REPORTS.LIST.EMPTY_HEADER")}
        content={t("TIME_REPORTS.LIST.EMPTY_MESSAGE")}
      />
    </Box>
  ) : (
    <Flex flexDirection="column" gap={["xs", null, "sm", "md"]} pb="lg">
      <ListViewHeader header={t("TIME_REPORTS.LIST.HEADER")} count={data.totalElements} />

      <Container>
        <Flex px={["0", null, "sm"]} flexDirection="column" gap="lg">
          <TimeReportsList timeReports={data.content} />

          <Pagination
            pagesCount={data.totalPages}
            activeIndex={data.number}
            onChangeIndex={setPage}
            pageSize={data.size}
            onChangePageSize={setSize}
            resultsLabel={t("public:COMPONENTS.PAGINATION.RESULTS")}
          />
        </Flex>
      </Container>
    </Flex>
  );
};
